import api from './api';

const realtorService = {
  getMyProfile: () => api.get('/realtors/profile/me').then((r) => r.data),
  saveMyProfile: (data) => api.put('/realtors/profile/me', data).then((r) => r.data),
  matchAgencies: (q) => api.get('/realtors/eac-agencies/match', { params: { q } }).then((r) => r.data),
  listDocuments: () => api.get('/realtors/documents').then((r) => r.data),
  deleteDocument: (id) => api.delete(`/realtors/documents/${id}`).then((r) => r.data),
  uploadDocument: (file, documentType, onProgress) => {
    const fd = new FormData();
    fd.append('file', file);
    fd.append('documentType', documentType);
    fd.append('documentName', file.name);
    return api.post('/uploads/documents', fd, {
      headers: { 'Content-Type': 'multipart/form-data' },
      onUploadProgress: (e) => onProgress && onProgress(Math.round((e.loaded * 100) / (e.total || 1))),
    }).then((r) => r.data);
  },
  dashboard: () => api.get('/realtors/dashboard').then((r) => r.data),
};

export default realtorService;
